import React, { useState, useCallback, useEffect, useRef } from 'react';
import {
  Route,
  Redirect,
  Switch,
  useLocation,
  useHistory,
} from 'react-router-dom';
import { Frame, Icon, TopBar, VisuallyHidden } from '@shopify/polaris';
import useToken from './hooks/useToken';
import Login from './components/Login/Login';
import Pricing from './components/Pricing/index';
import Widget from './components/Widget/Widget';
import SideMenu from './common/SideMenu';
import Support from './components/Support/Support';
import Templates from './components/Templates/index';
import Landing from './components/Landing/Landing';
import ChatSettings from './components/Widget/ChatSettings';
import { getOwnerDetails, getShopDetails } from './redux/actions/shop';
import { getShopSettings } from './redux/actions/shop';
import DowntimeMarkup from './common/DowntimeMarkup';
import CreateTemplate from './components/Messaging/ExtensionTemplates/CreateTemplate';
import PricingBannerMarkup from './common/PricingBannerMarkup';
import Confirmation from './common/Confirmation';
import { getPlanDetails } from './redux/actions/pricing';
import AutomatedAbandonedCart from './components/AbandonedCart';
import AutomatedCRMPage from './components/OrdersCRM/index';
import AutomatedCoDPage from './components/CashOnDelivery/index';
import CustomersPage from './components/OptinNumber/index';
import PrivateWABA from './components/PrivateWABA/index';
import CODPage from './components/CODPage/index';
import AdminConfiguration from './components/AdminConfiguration/AdminConfiguration';
import ManualMessages from './components/ManualMessages';
import EmailTemplates from './components/Email/Templates';
import Release_21_20_01_Modal from './components/WhatsNew/R21.20.01';
import Release_22_02_03_Modal from './components/WhatsNew/R22.02.03';
import Release_22_03_01_Modal from './components/WhatsNew/R22.03.01';
import Release_22_05_01_Modal from './components/WhatsNew/R23.05.01';
import BellRinging from './assets/icons/bell-ringing.gif';
import BellStatic from './assets/icons/bell-static.png';
import BellNotification from './assets/icons/bell-notification.gif';
import EmailConfiguration from './components/Email/Configuration/Configuration';
import WhatsappPreview from './components/WhatsappPreviewPage/index';
import Signup from './components/Signup/Signup';
import Profile from './components/Profile/Profile';
import Analytics_MessageLogs from './components/Analytics_MessageLogs/index';
import HomePage from './components/HomePage/index';
import './App.scss';

import CreateCampaign from './components/MarketingCampaigns/CreateCampaign';
import {
  getWabaDetailsbyShopId,
  loadWabaDetails,
} from './redux/actions/private-waba';
import MarketingCampaigns from './components/MarketingCampaigns';
import WABA from './components/WABA';
import Chatbot from './components/Chatbot';

import { clevertapEventPush, CT_EVENT_IDS } from './utils/clevertapUtils';
import { 
  PLAN_OLD_PRO, 
  PLAN_OLD_FREE, 
  APP_NAME, 
  UNAUTHORIZED_LINKS, 
  HIDE_FRAME_LINKS 
} from './constants/constants';

import {
  PlanIcon,
  SupportIcon,
  ReviewIcon,
  LogoutIcon,
} from './common/SvgIcons';
import TeamInbox from './components/TeamInbox';
import Messaging from './components/Messaging';
import Chat from './components/Chat';
import Wallet from './components/Wallet';

const App = () => {
  const { token, setToken } = useToken();
  const [showMenu, setShowMenu] = useState(false);
  const [showFrame, setShowFrame] = useState(false);
  const [showHomePage, setShowHomePage] = useState(false);
  const [showMobileNavigation, setShowMobileNavigation] = useState(false);
  const [owner, setOwner] = useState<any>();
  const [shopDetails, setShopDetails] = useState<any>();
  const [privateWabaDetails, setPrivateWabaDetails] = useState<any>();
  const [planId, setPlanId] = useState<any>();
  const [userMenuClicked, setUserMenuClicked] = useState(false);
  const [selectedTabForTemplate, setSelectedTabForTemplate] = useState(0);
  const [
    selectedTabForAnalytics_MessageLogs,
    setSelectedTabForAnalytics_MessageLogs,
  ] = useState(0);

  const [selectedTabForCustomersPage, setSelectedTabForCustomersPage] =
    useState(0);
  const [showWhatsNewTooltip, setShowWhatsNewTooltip] = useState(false);
  const [showReleaseModal_21_20_01, setShowReleaseModal_21_20_01] =
    useState(false);
  const [showReleaseModal_22_02_03, setShowReleaseModal_22_02_03] =
    useState(false);
  const [showReleaseModal_22_03_01, setShowReleaseModal_22_03_01] =
    useState(false);
  const [showReleaseModal_22_05_01, setShowReleaseModal_22_05_01] =
    useState(false);
  const [showPricingBanner, setShowPricingBanner] = useState();
  const bellClicked = localStorage.getItem('bell_clicked')
    ? localStorage.getItem('bell_clicked')
    : false;
  const appLaunched = useRef(false);
  const location = useLocation();
  const history = useHistory();
  let currentPath = history.location.pathname;
  const isForwardSlashPresent = currentPath.split('').pop();
  if (currentPath !== '/' && isForwardSlashPresent === '/') {
    currentPath = currentPath.slice(0, -1);
  }

  const eventPush = useCallback(
    () =>
      setTimeout(() => {
        clevertapEventPush({
          eventId: CT_EVENT_IDS.APP_LAUNCHED,
          eventData: {},
        });
        appLaunched.current = true;
      }, 1000),
    []
  );

  useEffect(() => {
    !appLaunched.current && eventPush();
  }, []);

  useEffect(() => {
    let shopDetails = JSON.parse(localStorage.getItem('shop') || '[]');
    let productTourViewed = JSON.parse(sessionStorage.getItem('productTourViewed') || '[]');
    let pathName = location.pathname === '/' ? `/home_${shopDetails.planId}` : `${location.pathname}_${shopDetails.planId}`;
    if(!productTourViewed.includes(pathName)) {
      setShowMobileNavigation(true);
    }
  }, [])

  useEffect(() => {
    const fetchShopDetails = () => {
      localStorage.setItem('private_waba', 'false');
      getShopDetails().then(async (response: any) => {
        if (response.status === 'success') {
          localStorage.setItem('currentPlan', response.shop.planId);
          setPlanId(localStorage.getItem('currentPlan'));
          setShopDetails(response.shop);
          //Next line to be removed if we are getting featuresList in shop API directly, no need to do another API call
          // await fetchPlanDetails(response.shop.planId);
          localStorage.setItem('features', response.shop.featuresList);
          localStorage.setItem('shop', JSON.stringify(response.shop));
          setShowMenu(true);
          setShowHomePage(true);
          getShopSettings(response.shop.userId).then((res: any) => {
            res &&
              res.settings &&
              localStorage.setItem(
                'shopSettings',
                JSON.stringify(res.settings)
              );
          });

          loadWabaDetails(response.shop.userId).then((res: any) => {
            setPrivateWabaDetails(res);
            if (res && res.appId && res.whatsappVerificationStatus) {
              localStorage.setItem('private_waba', 'true');
              localStorage.setItem(
                'whatsappVerificationStatus',
                res.whatsappVerificationStatus
              );
            }
          });
          getWabaDetailsbyShopId(response.shop.userId).then((res: any) => {
            if (res && res.appId && res.whatsappVerificationStatus) {
              localStorage.setItem('private_waba', 'true');
              localStorage.setItem(
                'whatsappVerificationStatus',
                res.whatsappVerificationStatus
              );
            }
          });
          fetchOwnerDetails(response.shop.userId);
        } else {
          if (currentPath !== '/cod-order') {
            history.push('/login');
          }
        }
      });
    };

    if (token) {
      fetchShopDetails();
    } else {
      setShowMenu(false);
    }
  }, [token]);

  useEffect(() => {
    if (!token && !UNAUTHORIZED_LINKS.includes(currentPath)) {
      history.push('/login');
    }
    if (
      HIDE_FRAME_LINKS.includes(currentPath)
    ) {
      setShowFrame(false);
    } else {
      setShowFrame(true);
    }
    const protectRoutes = () => {
      const fetchShopDetails = async () => {
        await getShopDetails().then((response: any) => {
          if (response.status === 'success') {
            checkIfRouteAllowed(
              response.shop.featuresList,
              response.shop.planId
            );
          } else {
            history.push('/login');
          }
        });
      };
      const checkIfRouteAllowed = (features: any, planId: string) => {
        if (Number(planId) === PLAN_OLD_FREE) {
          const routesNotAllowed = [
            '/manual-messaging',
            '/admin-config',
            '/optins',
          ];
          if (routesNotAllowed.indexOf(currentPath) !== -1) {
            history.push('/pricing');
          }
        }
        if (Number(planId) === PLAN_OLD_PRO) {
          const routesNotAllowed = ['/admin-config', '/optins'];
          if (routesNotAllowed.indexOf(currentPath) !== -1) {
            history.push('/pricing');
          }
        }
        return;
      };
      if (currentPath !== '/login' && currentPath !== '/') {
        fetchShopDetails();
      }
    };
    if (!UNAUTHORIZED_LINKS.includes(currentPath)) {
      protectRoutes();
    }
  }, [location.pathname]);

  //To be removed if we are getting featuresList in shop API directly, no need to do another API call
  const fetchPlanDetails = async (planId: string) => {
    await getPlanDetails(planId).then((res: any) => {
      if (res && res.plan) {
        localStorage.setItem('features', res.plan.featuresList);
      }
    });
  };

  const fetchOwnerDetails = (shopId: string) => {
    getOwnerDetails(shopId).then(
      (response: any) => {
        if (response.status === 'success') {
          localStorage.setItem('owner', JSON.stringify(response.owner));
          setOwnerDetails();
          // Send profile details after owner details has been fetched
          clevertapEventPush({
            eventId: CT_EVENT_IDS.USER_PUSH,
            eventData: {},
          });
        }
      },
      (err) => {
        setOwnerDetails();
      }
    );
  };

  const setOwnerDetails = () => {
    let ownerDetails = localStorage.getItem('owner')
      ? localStorage.getItem('owner')
      : '';
    setOwner(ownerDetails ? JSON.parse(ownerDetails) : '');
  };

  const hideFrame = (val: boolean) => {
    setShowFrame(val);
  };
  const handleMobileNavigation = () => {
    if (token) {
      setShowMobileNavigation((showMobileNavigation) => !showMobileNavigation);
    }
  };

  const changePath = (path: any) => {
    history.push(path);
  };
  const logout = () => {
    setToken('');
    removeToken();
    history.push('/login');
  };

  const { removeToken } = useToken();
  // TODO Add user image in place of initials
  const userMenuMarkup = token ? (
    //@ts-ignore
    <TopBar.UserMenu
      name={owner?.name}
      detail={owner?.shopName}
      initials={owner?.name?.charAt(0)}
      actions={[
        {
          items: [
            {
              content: 'Plans',
              onAction: () => {
                changePath('/pricing');
              },
              icon: PlanIcon,
            },
            {
              content: 'Support',
              onAction: () => {
                clevertapEventPush({
                  eventId: CT_EVENT_IDS.EMAIL_SUPPORT_CLICKED,
                  eventData: {},
                });
                window.open(
                  'mailto:support@superlemon.xyz?subject=I%20need%20help%20with%20WhatsApp%20chat%20—%20' +
                    shopDetails?.url,
                  '_blank'
                );
              },
              icon: SupportIcon,
            },
            {
              content: 'Write a Review',
              onAction: () => {
                clevertapEventPush({
                  eventId: CT_EVENT_IDS.WRITE_A_REVIEW_CLICKED,
                  eventData: {},
                });
                window.open(
                  'https://apps.shopify.com/' +
                    APP_NAME +
                    '?#modal-show=ReviewListingModal'
                );
              },
              icon: ReviewIcon,
            },
            {
              content: 'Logout',
              onAction: () => {
                clevertapEventPush({
                  eventId: CT_EVENT_IDS.LOGGED_OUT,
                  eventData: {},
                });
                logout();
              },
              icon: LogoutIcon,
            },
          ],
        },
      ]}
      open={userMenuClicked}
      onToggle={() => {
        setUserMenuClicked(!userMenuClicked);
      }}
    />
  ) : null;

  const secondaryMenuMarkup = token ? (
    <TopBar.Menu
      activatorContent={
        <span>
          <span className='bell-icon'>
            <img
              src={bellClicked ? BellStatic : BellNotification}
              alt='Release Notes'
              className={bellClicked ? '' : 'notification-bell'}
            />
          </span>
          <VisuallyHidden>Secondary menu</VisuallyHidden>
        </span>
      }
      open={showWhatsNewTooltip}
      onOpen={() => {
        setShowWhatsNewTooltip(true);
        localStorage.setItem('bell_clicked', 'true');
      }}
      onClose={() => setShowWhatsNewTooltip(false)}
      actions={[
        {
          items: [
            {
              content: 'Whats New!',
              onAction: () => {
                alert('Please click on any of the release versions');
              },
            },
          ],
        },
        {
          items: [
            {
              content: 'Release 23.01.09 *New*',
              onAction: () => {
                setShowReleaseModal_22_05_01(true);
              },
            },
          ],
        },
        {
          items: [
            {
              content: 'Release 22.03.01',
              onAction: () => {
                setShowReleaseModal_22_03_01(true);
              },
            },
          ],
        },
        {
          items: [
            {
              content: 'Release 22.02.03',
              onAction: () => {
                setShowReleaseModal_22_02_03(true);
              },
            },
          ],
        },
        {
          items: [
            {
              content: 'Release 21.20.01',
              onAction: () => {
                setShowReleaseModal_21_20_01(true);
              },
            },
          ],
        },
      ]}
    />
  ) : null;

  const topBarMarkup = (
    <div>
      <TopBar
        userMenu={token ? userMenuMarkup : null}
        secondaryMenu={secondaryMenuMarkup}
        showNavigationToggle
        onNavigationToggle={handleMobileNavigation}
      />
      {token ? (
        <div
          className='DropDownArrowTopBar'
          onClick={() => {
            setUserMenuClicked(!userMenuClicked);
          }}
        >
          <i className='arrow arrow-down'></i>
        </div>
      ) : null}
    </div>
  );
  const navigationMarkup = showMenu ? (
    <SideMenu
      setToken={setToken}
      planId={planId}
      shopDetails={shopDetails}
      privateWabaDetails={privateWabaDetails}
    />
  ) : null;

  return (
    <>
      <Route path='/cod-order'>
        <CODPage hideFrame={hideFrame}></CODPage>
      </Route>
      <Route path='/template-preview'>
        <WhatsappPreview hideFrame={hideFrame}></WhatsappPreview>
      </Route>
      <Route path='/signup'>
        <Signup
          setToken={setToken}
          setOwner={() => setOwnerDetails()}
        />
      </Route>
      <Route path='/profile'>
        <Profile></Profile>
      </Route>
      <Route path='/login'>
        <Login
          setToken={setToken}
          setOwner={() => setOwnerDetails()}
          hideFrame={hideFrame}
        />
      </Route>
      {showFrame ? (
        <Frame
          topBar={topBarMarkup}
          navigation={navigationMarkup}
          showMobileNavigation={showMobileNavigation}
          onNavigationDismiss={handleMobileNavigation}
        >
          {!token ? <Redirect to='/login' /> : null}
          <DowntimeMarkup />
          <PricingBannerMarkup setShowPricingBanner={setShowPricingBanner} />
          <Release_21_20_01_Modal
            open={showReleaseModal_21_20_01}
            closeModal={() => setShowReleaseModal_21_20_01(false)}
          />
          <Release_22_02_03_Modal
            open={showReleaseModal_22_02_03}
            closeModal={() => setShowReleaseModal_22_02_03(false)}
          />
          <Release_22_03_01_Modal
            open={showReleaseModal_22_03_01}
            closeModal={() => setShowReleaseModal_22_03_01(false)}
          />
          <Release_22_05_01_Modal
            open={showReleaseModal_22_05_01}
            closeModal={() => setShowReleaseModal_22_05_01(false)}
          />
          <Switch>
            <Route path='/home'>
              <HomePage></HomePage>
            </Route>
            <Route exact path='/widget' component={Widget} />
            <Route path='/widget/settings'>
              <ChatSettings showPricingBanner={showPricingBanner} />
            </Route>
            <Route path='/pricing'>
              <Pricing planId={planId} setPlanId={setPlanId} />
            </Route>
            <Route path='/support' component={Support} />
            <Route exact path='/templates'>
              <Templates
                privateWabaDetails={privateWabaDetails}
                selectedTabForTemplate={selectedTabForTemplate}
                showPricingBanner={showPricingBanner}
              />
            </Route>
            <Route
              path='/campaigns'
              render={(props) => (
                <MarketingCampaigns
                  {...props}
                  privateWabaDetails={privateWabaDetails}
                  showPricingBanner={showPricingBanner}
                />
              )}
            />
            <Route exact path='/email-templates'>
              <EmailTemplates />
            </Route>
            <Route exact path='/email-config'>
              <EmailConfiguration />
            </Route>
            <Route
              path='/templates/create'
              render={(props) => (
                <CreateTemplate
                  {...props}
                  setSelectedTabForTemplate={setSelectedTabForTemplate}
                />
              )}
            />
            <Route
              path='/messaging/create'
              render={(props) => (
                <CreateTemplate
                  {...props}
                  setSelectedTabForTemplate={setSelectedTabForTemplate}
                />
              )}
            />
            <Route
              path='/campaigns/create'
              render={(props) => (
                <CreateCampaign
                  {...props}
                  setSelectedTabForTemplate={setSelectedTabForTemplate}
                />
              )}
            />
            <Route exact path='/confirmation' component={Confirmation} />
            <Route
              path='/automated-abandoned-cart'
              component={AutomatedAbandonedCart}
            />
            <Route path='/automated-orders' component={AutomatedCRMPage} />
            <Route path='/automated-cod' component={AutomatedCoDPage} />

            <Route
              path='/private-waba'
              component={
                privateWabaDetails && !privateWabaDetails.embedded
                  ? PrivateWABA
                  : WABA
              }
            />
            <Route exact path='/optins'>
              <CustomersPage
                selectedTabForCustomersPage={selectedTabForCustomersPage}
                showPricingBanner={showPricingBanner}
              />
            </Route>
            <Route exact path='/admin-config'>
              <AdminConfiguration showPricingBanner={showPricingBanner} />
            </Route>
            <Route path='/manual-messaging'>
              <ManualMessages owner={owner} />
            </Route>
            <Route path='/analytics-message-logs'>
              <Analytics_MessageLogs
                planId={planId}
                selectedTabForAnalytics_MessageLogs={
                  selectedTabForAnalytics_MessageLogs
                }
                showPricingBanner={showPricingBanner}
              />
            </Route>
            <Route exact path='/'>
              {!showHomePage ? (
                <Login
                  setToken={setToken}
                  setOwner={() => setOwnerDetails()}
                  hideFrame={hideFrame}
                />
              ) : (
                <HomePage></HomePage>
              )}
            </Route>
            <Route path='/chatbot'>
              <Chatbot planId={planId} />
            </Route>
            <Route path='/team-inbox'>
              <TeamInbox />
            </Route>
            <Route path='/chat'>
              <Chat />
            </Route>
            <Route path='/messaging'>
              <Messaging />
            </Route>
            <Route path='/wallet'>
              <Wallet />
            </Route>
          </Switch>
        </Frame>
      ) : null}
    </>
  );
};

export default App;
